const RETRY_JITTER_MS = 1000;

export function getRetryDelayMs(status: number, attempt: number, err: any): number {
  if (status === 429) {
    const raw =
      err?.headers?.['retry-after'] ?? err?.data?.headers?.['retry-after'];
    if (raw) {
      const secs = parseInt(raw, 10);
      const fromHeader = isNaN(secs)
        ? new Date(raw).getTime() - Date.now()
        : secs * 1000;
      return Math.max(fromHeader, 0) + Math.random() * RETRY_JITTER_MS;
    }
    return 2000 + Math.random() * RETRY_JITTER_MS;
  }
  // 502 / 503 / FETCH_ERROR — exponential backoff + jitter
  return Math.pow(2, attempt) * 1000 + Math.random() * RETRY_JITTER_MS;
}
